import React, { useContext } from "react"
import Img from "gatsby-image"
import { MDXRenderer } from "gatsby-plugin-mdx"

import ContentfulDataContext from "../context/contentful-data"

const Books = props => {
  const { allContentfulBook } = useContext(ContentfulDataContext)

  if (!props.slugs || !props.slugs.length) {
    return null
  }

  const slugs = props.slugs.split(",").map(slug => slug.trim())

  const books = slugs
    .map(slug => {
      const filteredBooks = allContentfulBook.edges.filter(
        ({ node: boo }) => boo.slug === slug
      )

      if (!filteredBooks || !filteredBooks.length) {
        return false
      }

      return filteredBooks[0].node
    })
    .filter(boo => !!boo)

  if (!books || !books.length) {
    return null
  }

  books.forEach(book => {
    book.rate = []

    if (book.rating) {
      for (let i = 0; i < 5; i++) {
        const star = i < book.rating ? "★" : "☆"
        book.rate.push(star)
      }
    }
  })

  const isGrid = props.type && props.type === "grid"

  return (
    <>
      {isGrid ? (
        <section className="book-grid">
          {books.map((book, index) => (
            <article className="cell" key={`${book.contentful_id}-${index}`}>
              <a
                href={`/r/${book.slug}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Img
                  fluid={book.coverImage.fluid}
                  alt={book.title}
                  title={book.title}
                  className="cover-image"
                />
                {book.rate.length ? (
                  <span className="rating">{book.rate}</span>
                ) : (
                  ""
                )}
              </a>
            </article>
          ))}
        </section>
      ) : (
        <section className="book-list">
          {books.map((book, index) => (
            <article className="row" key={`${book.contentful_id}-${index}`}>
              <div className="cover">
                <a
                  href={`/r/${book.slug}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Img
                    fluid={book.coverImage.fluid}
                    alt={book.title}
                    title={book.title}
                    className="cover-image"
                  />
                  {book.rate.length ? (
                    <span className="rating">{book.rate}</span>
                  ) : (
                    ""
                  )}
                </a>
              </div>
              <div className="intro">
                <h4 className="title">{book.title}</h4>
                {book.childContentfulMdx && book.childContentfulMdx.childMdx ? (
                  <MDXRenderer>
                    {book.childContentfulMdx.childMdx.body}
                  </MDXRenderer>
                ) : (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: book.excerpt ? book.excerpt.excerpt : "",
                    }}
                  ></div>
                )}
              </div>
            </article>
          ))}
        </section>
      )}
    </>
  )
}

export default Books
